"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _ = _interopRequireDefault(require("@carbon/icons-react/lib/arrow--right/24.js"));
var _SIASearch = require("./SIASearch");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const VacanciesResults = _ref => {
  let {
    text,
    vacancies,
    lang,
    translate
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "vacancies sia-padding-04-bottom sia-margin-02-bottom"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-03  sia-margin-03-bottom"
  }, translate('cms.search.vacancies')), vacancies.map(el => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "sia-border-01-bottom sia-padding-03-bottom sia-margin-03-bottom",
      key: el.title
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "sia-text-12",
      dangerouslySetInnerHTML: {
        __html: (0, _SIASearch.setHighlightText)(el.title, text)
      }
    }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      className: "link",
      to: `/${lang}/cms${el.alias}`
    }, /*#__PURE__*/_react.default.createElement(_.default, {
      className: "page-action-down-32"
    })));
  }));
};
var _default = exports.default = VacanciesResults;